import { render, staticRenderFns } from "./ReportClose.vue?vue&type=template&id=2b43f6d3"
import script from "./ReportClose.vue?vue&type=script&lang=js"
export * from "./ReportClose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports